"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocale = void 0;
const yup = __importStar(require("yup"));
/**
 * This method transforms schema paths to be more readable in validation errors.
 * @param path yup schema path
 * @returns filtered schema path
 */
const pathFilter = (path) => {
    switch (path) {
        case 'content.contentType':
            return 'Content type';
        case 'content.knownContent.content':
            return 'Known content';
        case 'content.knownContent.amount':
            return 'Known content amount';
        case 'content.estimatedSpecificContent.primary':
            return 'Primary content';
        case 'content.estimatedSpecificContent.secondary':
            return 'Secondary content';
        case 'content.estimatedGeneralContent':
            return 'Estimated content';
        case 'bundleOrRoll':
            return 'Bundle or Roll';
        case 'knitOrWoven':
            return 'Knit or Woven';
        case 'widthCM':
        case 'widthIn':
        case 'widthMM':
            return 'Width';
        case 'lengthM':
        case 'lengthIn':
        case 'lengthCM':
            return 'Length';
        case 'sellingUnit':
            return 'Selling Unit';
        case 'buttonType':
        case 'patternType':
        case 'threadType':
        case 'trimType':
        case 'elasticType':
            return 'Type';
        case 'patternNumber':
            return 'Pattern Number';
        case 'threadOnSpool':
            return 'Thread on Spool';
        case 'spoolSize':
            return 'Spool Size';
        case 'trimLengthType':
            return 'Known or Estimated';
        case 'trimContent':
            return 'Content';
        case 'packSize':
            return 'Pack Size';
        case 'packSizeType':
            return 'Pack Size Type';
        default:
            return `${path[0].toUpperCase()}${path.substring(1)}`;
    }
};
const setLocale = () => {
    // Edit paths on error messages
    yup.setLocale({
        mixed: {
            required: ({ path }) => {
                return `${pathFilter(path)} is required`;
            },
            defined: ({ path }) => {
                return `${pathFilter(path)} must be defined`;
            }
        },
        string: {
            max: ({ max, path }) => {
                return `${pathFilter(path)} must be at most ${max} characters`;
            },
            min: ({ min, path }) => {
                return `${pathFilter(path)} must be at least ${min} characters`;
            },
            matches: ({ regex, path }) => {
                const baseMsg = `${pathFilter(path)} should only contain alphabet`;
                const specialChars = regex.source.slice('^[A-Za-z'.length, regex.source.length - ']+$'.length);
                if (specialChars.length > 0)
                    return `${baseMsg} and special characters (${specialChars})`;
                return `${baseMsg} characters`;
            }
        },
        array: {
            max: ({ max, path }) => {
                return `${pathFilter(path)} must have at most ${max} items`;
            },
            min: ({ min, path }) => {
                return `${pathFilter(path)} must have at least ${min} items`;
            }
        }
    });
};
exports.setLocale = setLocale;
//# sourceMappingURL=pathFilter.js.map